import React from 'react';
import FaqQuestion from './faqquestion';

const FaqSection = ({sport}) => {

  // TODO Get this from CMS
  const questions = [
    {
      "category": "allgemein",
      "question": "Was ist das Mindestalter, um an einem Kurs teilnehmen zu können?",
      "answer": "In der Regel ab 8 Jahren. Das Schwimmabzeichen 'Freischwimmer' (DLRG Bronze) oder vergleichbares ist Voraussetzung (oder Seeepferdchen unter Aufsicht der Eltern). Für Kinder bieten wir auch indivuelle Kitesurfkurse an."
    },
    {
      "category": "allgemein",
      "question": "Kann ich mehrmals einen Schnupper-, Einsteiger- oder Grundkurs buchen?",
      "answer": "Ja, das ist möglich. Vor allem Kinder schnuppern gerne mehrmals."
    },
    {
      "category": "allgemein",
      "question": "Kann ich meinen gebuchten Kurs stornieren?",
      "answer": "Ja, unsere Stornierungsbedingungen findest Du in unserer AGB." 
    },
    {
      "category": "allgemein",
      "question": "Ist ein Neoprenanzug im Preis inbegriffen?",
      "answer": "In allen unseren Kursen ist ein Neoprenanzug im Kurspreis inbegriffen. Beim Materialverleih ist ein Neoprenanzug nicht im Preis inbegriffen." 
    },
    {
      "category": "allgemein",
      "question": "Muss ich schwimmen können, um an einem Kurs teilnehmen zu können?",
      "answer": "Ja! Der Freischwimmer (DLRG Bronze) oder das Seepferdchen (unter Aufsicht der Eltern) ist Voraussetzung, um an unseren Kursen teilnehmen zu können." 
    },
    {
      "category": "allgemein",
      "question": "Wie kann ich bei euch bezahlen?",
      "answer": "Bei uns kannst Du direkt am Strand per EC Karte, Kreditkarte oder in Bar bezahlen." 
    },
    {
      "category": "wellenreiten",
      "question": "Gibt es auf Langeoog geeignete Wellen zum Wellenreiten?",
      "answer": "Ja, Langeoog bietet aufgrund seiner Lage mit die Besten Wellen der ostfriesischen Inseln."
    },
    {
      "category": "kitesurfen",
      "question": "Wie lange brauche ich, um Kiten zu lernen?",
      "answer": "Nach dem Grundkurs sind die meisten soweit, gemeinsam mit einem Partner eigenständig weiter zu üben (abhängig vom Revier und den Bedingungen). Nach ca. 20 Stunden Übungszeit am Kite sind die meisten so weit, sicher hin und her zu fahren."
    },
    {
      "category": "kitesurfen",
      "question": "Kann ich nach meinen Schnupperkurs zu einem Grundkurs upgraden?",
      "answer": "Ja, Du kannst zum Preis von (250€) auf den Grundkurs upgraden."
    },
    {
      "category": "kitesurfen",
      "question": "Wie fit muss ich sein, um an einem Kitekurs teilnehmen zu können?",
      "answer": "Die Dauer unserer Kitekurse beträgt 2 - 3 Stunden pro Tag (Gruppenkurs / abwechselnd am Kite). Wer sich nicht zutraut, so lange aktiv zu trainieren, sollte besser eine Privatstunde buchen (auf Anfrage)."
    },
    {
      "category": "sup",
      "question": "Kann ich nach meinen Schnupperkurs zu einem Grundkurs upgraden?",
      "answer": "Ja, Du kannst zum Preis von (50€) auf den Grundkurs upgraden."
    },
    {
      "category": "wingfoilen",
      "question": "Kann ich nach meinen Schnupperkurs zu einem Grundkurs upgraden?",
      "answer": "Ja, Du kannst zum Preis von (59€) auf den Grundkurs upgraden."
    },
    {
      "category": "verleih",
      "question": "Was passiert, wenn ich geliehenes Surf-Equipment beschädige?",
      "answer": "Im Fall eines Schadens musst Du leider für den entstandenen Schaden aufkommen. Daher empfehlen wir den Abschluss des VDWS Safety Tools."
    },
    {
      "category": "verleih",
      "question": "Kann ich Material auch für 0,5h oder 1,5h leihen?",
      "answer": "Nein, Material kann nur für volle Stunden geliehen werden."
    }
  ];

  const categoryQuestions = questions.filter(question => {
    if(sport === "all") return question;
    if(question.category === sport || question.category === "allgemein") {return question} else return false;
  })

  return ( 
    <div>
      {categoryQuestions.map((question, index) => {
        return <FaqQuestion faq={question} key={index} /> 
      })}
    </div>
   );
}
 
export default FaqSection;